import { ISliderConf } from '@notino/react-styleguide';

export const THUMBS_SLIDER_CONFIG: ISliderConf = {
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
  ],
};
